import type { Item } from '@/common/api/types/items';
import { ReadOnlyAdapterError } from '@/features/items/mutations/dependencyErrors';
import type { DependencyTabAdapter, PlanSchedulingScenarioContext } from '../types';

export const createReadOnlyDependencyAdapter = ({
  item: _item,
  scenarioContext,
}: {
  item: Item;
  scenarioContext?: PlanSchedulingScenarioContext;
}): DependencyTabAdapter => {
  const isEditable = (_dependencyId?: number): boolean => false;
  const isDisabled = (_dependencyId?: number): boolean => false;
  const isVisible = (_dependencyId?: number): boolean => true;
  const canAddDependency = (): boolean => false;
  const addDependency = async (_predecessorId: number, _successorId: number): Promise<void> => {
    throw new ReadOnlyAdapterError();
  };
  const removeDependency = async (_predecessorId: number, _successorId: number): Promise<void> => {
    throw new ReadOnlyAdapterError();
  };

  return {
    isEditable,
    isDisabled,
    isVisible,
    canAddDependency,
    addDependency,
    removeDependency,
    scenarioContext,
  };
};
